import { styled } from '@mui/material';

interface PoppedProps {
  isPopped?: boolean;
}

export const DrawerContentWrapper = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  flex: 1,
  // Allow this flex item to shrink so overflow applies; wide spreadsheet scrolls here only.
  minHeight: 0,
  minWidth: 0,
  overflow: 'auto',
}));

// One in-flow layout for BOTH mounting contexts. The popout used to switch this
// header to position:fixed and compensate with paddingTop on the content wrapper
// alone - which buried the side panel's header (bulk select-all, filters) under
// the fixed bar, since the panel column got no compensation (SCAL-8976 popout).
// Sticky inside a non-scrolling column simply stays in flow, exactly like docked.
export const DrawerHeader = styled('div')({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: '2rem',
  borderBottom: '1px solid #BDC4CB',
  minWidth: 0,
});

export const DrawerHeaderContent = styled('div')<PoppedProps>(({ theme, isPopped }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 1,
  paddingLeft: theme.spacing(2),
  minWidth: 0,
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  ...(!isPopped && {
    '@media (max-width: 768px)': {
      paddingLeft: theme.spacing(1.5),
    },
    '@media (max-width: 480px)': {
      paddingLeft: theme.spacing(1),
    },
  }),
}));

export const DrawerSizeBar = styled('div')({
  height: '3px',
  cursor: 'row-resize',
  backgroundColor: '#ccc',
});
